<mat-dialog-content>
  @if (data.title) {
    <div class="group-header">
      {{data.title}}
    </div>
  }

  @if (data.texts) {
    <div class="hw-text-align-left">
      @for (text of data.texts; track text) {
        <div [innerHTML]="text | safeHtml">
        </div>
      }
    </div>
  }

</mat-dialog-content>
<mat-dialog-actions class="hw-justify-content-center hw-padding-bottom-1em-important">
  <button mat-dialog-close mat-raised-button class="custom-next-button next-button-style custom-next-button-width" cdkFocusInitial>OK</button>
</mat-dialog-actions>
